import { mapperModuleInternalVideo, mapperModuleMedia, mapperModuleVideo } from '../../modules/mappers'
import { mapperBlockMetrics, mapperBlockContent, mapperBlockSimpleQuote, mapperBlockIndexHighlight } from '../mappers'
import imageSizes from '../../../constants/imageSizes'
import type { MapperImageOptions, MapperOptions } from '~/types'

const blocksModuleMediaImageOptions: MapperImageOptions = {
  lazy: true,
  sizes: {
    small: { ...imageSizes.columns12_21.small },
    medium: { ...imageSizes.columns12_21.medium },
    large: { ...imageSizes.columns10_21.large }
  }
}
const blocksModuleVideoImageOptions: MapperImageOptions = {
  lazy: true,
  sizes: {
    small: { width: 344, height: 127, aspectRatio: '2/1' },
    medium: { width: 690, height: 345, aspectRatio: '2/1' },
    large: { width: 1176, height: 588, aspectRatio: '2/1' }
  }
}

export const mapperBlockIndexContentGroup = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  if (data.lazy) {
    return data
  }

  const mapBlock = (item: any, options: MapperOptions) => {
    const mappersByContentType = {
      ModuleMedia: (data: any) => mapperModuleMedia(data, blocksModuleMediaImageOptions),
      ModuleVideo: (data: any) => mapperModuleVideo(data, blocksModuleVideoImageOptions),
      ModuleInternalVideo: (data: any) => mapperModuleInternalVideo(data, blocksModuleVideoImageOptions),
      BlockMetrics: (data: any) => mapperBlockMetrics(data),
      BlockContent: (data: any) => mapperBlockContent(data, options),
      BlockSimpleQuote: (data: any) => mapperBlockSimpleQuote(data, options.imageOptions),
      BlockIndexHighlight: (data: any) => mapperBlockIndexHighlight(data, options)
    }
    const mapper = mappersByContentType[item.contentType] || ((data: any) => data)
    if (!mappersByContentType[item.contentType]) {
      // eslint-disable-next-line no-console
      console.warn(`Mapper missing for content type for ${JSON.stringify(item)}`)
    }
    const mappedItem = mapper(item)
    mappedItem.contentType = item.contentType
    return mappedItem
  }

  return {
    id: data.sys?.id || '',
    contentBlocks:
      data.contentBlocksCollection?.items?.filter(Boolean).map((item: any) => mapBlock(item, options)) || []
  }
}
